export const TRACKING_PAGE_EVENT_NAMES = {
	ROUTER_HOME_VIEWED: "router_home_viewed",
	SELECT_SPOT_VIEWED: "select_spot_viewed",
} as const;

export type TrackingPageEventName = (typeof TRACKING_PAGE_EVENT_NAMES)[keyof typeof TRACKING_PAGE_EVENT_NAMES];

export const TRACKING_EVENT_NAMES = {
	DOWNLOAD_APP_CLICK: "download_app_click",
	CONTINUE_WITHOUT_ADVANTAGE_CLICK: "continue_without_advantage_click",
	HELP_CLICK: "help_click",
	SPOT_SELECTED: "spot_selected",
	BACK_CLICK: "back_click",
} as const;

export type TrackingEventName = (typeof TRACKING_EVENT_NAMES)[keyof typeof TRACKING_EVENT_NAMES];
